import { render, staticRenderFns } from "./TriageView.vue?vue&type=template&id=41ad73d4&scoped=true&"
import script from "./TriageView.vue?vue&type=script&lang=ts&"
export * from "./TriageView.vue?vue&type=script&lang=ts&"
import style0 from "./TriageView.vue?vue&type=style&index=0&id=41ad73d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad73d4",
  null
  
)

export default component.exports